import { render, staticRenderFns } from "./TfaCard.htm?vue&type=template&id=4d428382&scoped=true&"
import script from "./TfaCard.js?vue&type=script&lang=js&"
export * from "./TfaCard.js?vue&type=script&lang=js&"
import style0 from "./TfaCard.scss?vue&type=style&index=0&id=4d428382&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d428382",
  null
  
)

export default component.exports